<template>
  <v-container fluid>
    <v-row align="center" justify="center" v-if="!checkedUser">
      <v-col
        cols="12"
        lg="6"
        md="6"
        class="fill-height d-flex flex-column justify-center align-center"
      >
        <v-form ref="formPhone" style="width: 100%">
          <v-card style="width: 100%">
            <v-card-text class="body-1">
              <v-text-field
                v-model="formUser.portable"
                filled
                dense
                :rules="[obligatoireRule()]"
                :label="$t('user.details.portable')"
              />

              <date-picker
                :label="$t('user.details.dateNaissance')"
                v-model="formUser.dateDeNaissance"
                :close-on-content-click="false"
                :first-day-of-week="1"
                :date-formatter="dateFormatter"
                :max="new Date().toISOString().substr(0, 10)"
                :startByYear="true"
                :rules="[obligatoireRule(), serveurRule('dateDeNaissance')]"
              />
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="checkUser">
                {{ $t('button.confirm') }}
              </v-btn>
              <v-btn
                text
                :to="{
                  name: 'Login',
                  params: { namespaceonly: true },
                }"
              >
                {{ $t('button.cancel') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
    <v-row align="center" justify="center" v-if="checkedUser">
      <v-col
        cols="12"
        lg="6"
        md="6"
        class="fill-height d-flex flex-column justify-center align-center"
      >
        <answerQuestion
          ref="answerQuestion"
          :question="question"
          @emitQuestion="emitQuestion"
          @emitResponse="emitResponse"
          :serveurRule="serveurRule"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ErrorServeur from '@/plugins/mixins/ErrorServeur'
import toasted from '@/utils/toasted'
import AnswerQuestion from '@/view/Forgot/AnswerQuestion'
import ServeurRule from '@/plugins/mixins/ServeurRule'
import DateFormatter from '@/plugins/mixins/DateFormatter'

export default {
  mixins: [ErrorServeur, ServeurRule, DateFormatter],
  components: {
    answerQuestion: AnswerQuestion,
  },
  data() {
    return {
      formUser: {
        portable: null,
        dateDeNaissance: null,
      },
      question: {
        id: null,
        questionen: null,
        questionfr: null,
      },
      response: null,
      checkedUser: false,
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    emitResponse(value) {
      this.response = value
    },

    emitQuestion() {
      this.resetPassword()
    },
    __validerPhone() {
      this.resetErreur()
      if (this.$refs.formPhone) {
        const ok = this.$refs.formPhone.validate()
        return ok
      } else {
        return true
      }
    },

    __validerQuestion() {
      this.resetErreur()
      return this.$refs.answerQuestion.validerQuestion
    },

    getForms() {
      //access aux formulaire à créer
      if (this.checkedUser) {
        return this.$refs.answerQuestion.getForms()
      }
      if (!this.checkedUser) {
        return [this.$refs.formPhone]
      }
    },
    checkUser() {
      //lance la validation
      const ok = this.__validerPhone()
      if (ok) {
        this.$api('/resetPassword/user/phone', '/oauth')
          .post({
            portable: this.formUser.portable,
            dateDeNaissance: this.formUser.dateDeNaissance,
          })
          .then((response) => {
            this.question = response.body
            this.checkedUser = true
          })
          .catch((errors) => {
            this.errorsHandler(errors)
          })
      }
    },
    resetPassword() {
      //lance la validation
      const ok = this.__validerQuestion()
      if (ok) {
        this.$api('/forgotLogin', '/oauth')
          .post({
            idQuestion: this.question.id,
            response: this.response,
            phone: this.formUser.portable,
          })
          .then((response) => {
            this.question = response.body
            this.checkedUser = false
            toasted.info(this.$t('forgot.confirmationSMSSent'))
            this.$router.push({ name: 'Login' })
          })
          .catch((errors) => {
            this.errorsHandler(errors)
          })
      }
    },
  },
  validations: {},
}
</script>
